import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", {
  for: "name",
  class: "form-label"
}, "Name", -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "displayname",
  class: "form-label"
}, "DisplayName", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "phone",
  class: "form-label"
}, "Phone", -1)
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "form-label"
}, "Email", -1)
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "status",
  class: "form-label"
}, "Status", -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Event Producers ")
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "card-header" }
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { class: "card-text" }
const _hoisted_19 = { class: "list-group list-group-flush" }
const _hoisted_20 = { class: "list-group-item" }
const _hoisted_21 = { class: "input-group mb-3" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "authTypeLabel"
}, "Type", -1)
const _hoisted_23 = {
  key: 0,
  class: "input-group mb-3"
}
const _hoisted_24 = {
  key: 1,
  class: "input-group mb-3"
}
const _hoisted_25 = { class: "input-group mb-3" }
const _hoisted_26 = /*#__PURE__*/_createVNode("option", { value: false }, "No", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: true }, "Yes", -1)
const _hoisted_28 = { class: "list-group-item" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Testing account", -1)
const _hoisted_30 = { class: "input-group mb-3" }
const _hoisted_31 = { class: "input-group mb-3" }
const _hoisted_32 = /*#__PURE__*/_createVNode("option", { value: false }, "No", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("option", { value: true }, "Yes", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  id: "save",
  class: "btn btn-primary"
}, "save", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_block = _resolveComponent("error-block")
  const _component_BIconArrowRepeat = _resolveComponent("BIconArrowRepeat")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createVNode(_component_error_block, { errors: _ctx.errors }, null, 8, ["errors"]),
    (_ctx.company.id)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("fieldset", null, [
            _createVNode("form", {
              id: 'company_' + _ctx.company.id,
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.callSave()), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "name",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.company.Name = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.company.Name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "displayname",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.company.DisplayName = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.company.DisplayName,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "phone",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.company.Phone = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.company.Phone,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "email",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.company.Email = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.company.Email,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  id: "status",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.company.Status = $event))
                }, [
                  (_openBlock(), _createBlock(_Fragment, null, _renderList({'active': 'Active', 'inactive': 'Disabled'}, (value, idx) => {
                    return _createVNode("option", {
                      key: idx,
                      value: idx
                    }, _toDisplayString(value), 9, ["value"])
                  }), 64))
                ], 512), [
                  [
                    _vModelSelect,
                    _ctx.company.Status,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("h5", null, [
                  _hoisted_14,
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-link btn-sm",
                    "aria-label": "Add",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addProducer('sheqsy')))
                  }, "add new sheqsy producer")
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.company.Producers, (producer, idx) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "col-md-6 gy-2",
                    key: idx
                  }, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createTextVNode(_toDisplayString(producer.Name), 1),
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-link btn-sm",
                          "aria-label": "Add",
                          onClick: ($event: any) => {_ctx.company.Producers.splice(idx, 1); _ctx.producerAuth.splice(idx, 1);}
                        }, "remove", 8, ["onClick"])
                      ]),
                      _createVNode("div", _hoisted_17, [
                        _createVNode("p", _hoisted_18, [
                          _createVNode("ul", _hoisted_19, [
                            _createVNode("li", _hoisted_20, [
                              _createVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _withDirectives(_createVNode("select", {
                                  class: "form-control",
                                  id: "authtype",
                                  "onUpdate:modelValue": ($event: any) => (_ctx.producerAuth[idx].type = $event)
                                }, [
                                  _createVNode("option", {
                                    name: 'producerAuth-'+idx+'-type',
                                    value: "user"
                                  }, "Username / Password", 8, ["name"]),
                                  _createVNode("option", {
                                    name: 'producerAuth-'+idx+'-type',
                                    value: "token"
                                  }, "Token", 8, ["name"])
                                ], 8, ["onUpdate:modelValue"]), [
                                  [
                                    _vModelSelect,
                                    _ctx.producerAuth[idx].type,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              (_ctx.producerAuth[idx].type == 'user')
                                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                                    _createVNode("span", {
                                      class: "input-group-text sm-3",
                                      id: 'producerAuth-'+idx+'-user',
                                      style: {"min-width":"4em"}
                                    }, "Username", 8, ["id"]),
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      "aria-describedby": 'producerAuth-'+idx+'-user',
                                      class: "form-control",
                                      id: 'producerAuth-'+idx+'-user-val',
                                      "onUpdate:modelValue": ($event: any) => (_ctx.producerAuth[idx].user = $event)
                                    }, null, 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                                      [
                                        _vModelText,
                                        _ctx.producerAuth[idx].user,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ]),
                                    _createVNode("span", {
                                      class: "input-group-text sm-3",
                                      id: 'producerAuth-'+idx+'-pass',
                                      style: {"min-width":"4em"}
                                    }, "Password", 8, ["id"]),
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      "aria-describedby": 'producerAuth-'+idx+'-pass',
                                      class: "form-control",
                                      id: 'producerAuth-'+idx+'-pass-val',
                                      "onUpdate:modelValue": ($event: any) => (_ctx.producerAuth[idx].pass = $event)
                                    }, null, 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                                      [
                                        _vModelText,
                                        _ctx.producerAuth[idx].pass,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.producerAuth[idx].type == 'token')
                                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                                    _createVNode("span", {
                                      class: "input-group-text sm-3",
                                      id: 'producerAuth-'+idx+'-token',
                                      style: {"min-width":"4em"}
                                    }, "Token", 8, ["id"]),
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      "aria-describedby": 'producerAuth-'+idx+'-token',
                                      class: "form-control",
                                      id: 'producerAuth-'+idx+'-token-val',
                                      "onUpdate:modelValue": ($event: any) => (_ctx.producerAuth[idx].token = $event)
                                    }, null, 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                                      [
                                        _vModelText,
                                        _ctx.producerAuth[idx].token,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ]),
                                    _createVNode("button", {
                                      type: "button",
                                      class: "btn",
                                      "aria-label": "Regenerate",
                                      onClick: ($event: any) => (_ctx.refreshProducerToken(idx))
                                    }, [
                                      _createVNode(_component_BIconArrowRepeat)
                                    ], 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_25, [
                                _createVNode("span", {
                                  class: "input-group-text sm-3",
                                  id: 'producerenabled-'+idx,
                                  style: {"min-width":"4em"}
                                }, "Enabled", 8, ["id"]),
                                _withDirectives(_createVNode("select", {
                                  class: "form-control",
                                  "aria-describedby": 'producerenabled-'+idx,
                                  id: 'producerenabled-'+idx+'-val',
                                  "onUpdate:modelValue": ($event: any) => (producer.Enabled = $event)
                                }, [
                                  _hoisted_26,
                                  _hoisted_27
                                ], 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                                  [_vModelSelect, producer.Enabled]
                                ])
                              ])
                            ]),
                            _createVNode("li", _hoisted_28, [
                              _hoisted_29,
                              _createVNode("div", _hoisted_30, [
                                _createVNode("span", {
                                  class: "input-group-text sm-3",
                                  id: 'producerTestAuth-'+idx+'-user',
                                  style: {"min-width":"4em"}
                                }, "Username", 8, ["id"]),
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  "aria-describedby": 'producerTestAuth-'+idx+'-user',
                                  class: "form-control",
                                  id: 'producerTestAuth-'+idx+'-user-val',
                                  "onUpdate:modelValue": ($event: any) => (producer.TestUser = $event)
                                }, null, 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                                  [
                                    _vModelText,
                                    producer.TestUser,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createVNode("span", {
                                  class: "input-group-text sm-3",
                                  id: 'producerTestAuth-'+idx+'-pass',
                                  style: {"min-width":"4em"}
                                }, "Password", 8, ["id"]),
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  "aria-describedby": 'producerTestAuth-'+idx+'-pass',
                                  class: "form-control",
                                  id: 'producerTestAuth-'+idx+'-pass-val',
                                  "onUpdate:modelValue": ($event: any) => (producer.TestPassword = $event)
                                }, null, 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                                  [
                                    _vModelText,
                                    producer.TestPassword,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              _createVNode("div", _hoisted_31, [
                                _createVNode("span", {
                                  class: "input-group-text sm-3",
                                  id: 'producerTestEnabled-'+idx,
                                  style: {"min-width":"4em"}
                                }, "Enabled", 8, ["id"]),
                                _withDirectives(_createVNode("select", {
                                  class: "form-control",
                                  "aria-describedby": 'producerTestEnabled-'+idx,
                                  id: 'producerTestEnabled-'+idx+'-val',
                                  "onUpdate:modelValue": ($event: any) => (producer.TestEnabled = $event)
                                }, [
                                  _hoisted_32,
                                  _hoisted_33
                                ], 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                                  [_vModelSelect, producer.TestEnabled]
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _hoisted_34,
              _hoisted_35
            ], 40, ["id"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}